module.exports = __webpack_public_path__ + "img/avatar1.a8a43121.png";